import React from 'react';
import { AlertTriangle, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { getCurrentUser, hasPermission } from '../utils/roles';

const landingRoutes = [
  { path: '/dashboard', permission: 'View Dashboard' },
  { path: '/clients', permission: 'View Clients' },
  { path: '/transactions', permission: 'View Transactions' },
  { path: '/calendar', permission: 'View Calendar' },
  { path: '/documents', permission: 'View Documents' },
  { path: '/offices', permission: 'View Offices' },
  { path: '/users', permission: 'View Users' },
  { path: '/analytics', permission: 'View Analytics' },
  { path: '/affiliates', permission: 'View Affiliates' },
  { path: '/settings', permission: 'View Settings' },
];

const getHomePath = () => {
  const user = getCurrentUser();
  const route = landingRoutes.find(item => !item.permission || hasPermission(user, item.permission));
  return route?.path || '/404';
};

export default function NotFound() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className="flex min-h-full items-center justify-center p-6">
      <div className={`w-full max-w-lg rounded-lg border p-8 text-center shadow-2xl ${
        isDark ? 'border-gray-800 bg-[#0f1729]' : 'border-gray-200 bg-white'
      }`}>
        <div className={`mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full ${
          isDark ? 'bg-purple-500/15 text-purple-300' : 'bg-purple-50 text-purple-600'
        }`}>
          <AlertTriangle size={26} />
        </div>
        <div className={`text-sm font-semibold uppercase tracking-wider ${
          isDark ? 'text-purple-300' : 'text-purple-600'
        }`}>
          404
        </div>
        <h1 className={`mt-2 text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Page not found
        </h1>
        <p className={`mt-3 text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          The link is broken or the page has been moved.
        </p>
        <button
          type="button"
          onClick={() => navigate(getHomePath(), { replace: true })}
          className="mx-auto mt-6 inline-flex items-center gap-2 rounded-md bg-purple-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-purple-700"
        >
          <Home size={16} />
          Go to home
        </button>
      </div>
    </div>
  );
}
